import React from "react";

export default function InfoPanel({
  title,
  children,
  variant = "light", // "light" or "primary"
  className = "",
  headerClass = "",
}) {
  const headerBase = "p-3 border-top-3 text-center";
  const headerVariantClass =
    variant === "primary" ? "bg-primary text-white fw-bold" : "bg-light text-dark fw-bold";
  return (
    <div style={{ overflow: "clip" }} className={`rounded-3 bg-white shadow-sm mb-3 ${className}`}>
      {title && <div style={{background: variant === "primary" ? "#2C7BE5" : "#CFCFCF"}} className={`${headerBase} ${headerVariantClass} ${headerClass}`}>{title}</div>}
      <div className="p-4">{children}</div>
    </div>
  );
}